import DataExchange from './DataExchange'

import QueryString from '@/utils/QueryString'

const DURATION_QS = 'DurationInterval'

export default class DurationWFFMDataExchange extends DataExchange {
  /**
   * @param {HTMLFormElement} form
   */
  constructor (form) {
    super(form)

    /** @type {NodeList} */
    this.ranges = form.querySelectorAll('.custom-select-duration input[type="radio"]')
    this.initValuesFromQueryString()
  }

  get data () {
    return {
      ranges: this.ranges.map(range => ({
        name: `${range.value.split(':').join('-')} dni`,
        value: range.value,
        enabled: false,
      })),
      range: this.ranges.filter(range => range.checked).map(range => range.value).firstOrDefault('6:9'),
    }
  }

  set data (value) {
    this.ranges
      .filter(range => range.value === value.range)
      .forEach(range => { range.checked = 'checked' })
  }

  get queryComponent () {
    return `DurationInterval=${this.data.range}`
  }

  initValuesFromQueryString () {
    const qs = new QueryString()
    if (qs.exists(DURATION_QS)) {
      const selected = qs.get(DURATION_QS)
      this.ranges.forEach(range => { range.checked = range.value === selected })
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/DurationWFFMDataExchange.js